
const topVideo = (() => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {



    let sW = window.innerWidth;

    const secVideo = document.getElementById('jsSecVideo');
    const videoWrap = secVideo.querySelector('.js-video-wrap');
    const video = videoWrap.querySelector('video');

    video.load()


    let tl = gsap.timeline({
      scrollTrigger: {
        invalidateOnRefresh: true,
        trigger: videoWrap,
        start: "0% 100%",
        onEnter: () => video.play(),
        // markers: true,
      },
    })


    let target = document.querySelector('body');
    let observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        tl.scrollTrigger.refresh()
      });
    });
    observer.observe(target);



  }
})();
export default topVideo;